import React from 'react';
import { FaFacebookF, FaUsers, FaHandsHelping } from 'react-icons/fa';
import { Heading, PageTitle } from '../../../components';
import { kolejWaskotorowaData, images } from '../../../constants'; // Opcjonalnie zaimportuj 'images', jeśli stamtąd bierzesz logo
import '../KolejWaskotorowa.css';
import { useTranslation } from 'react-i18next'; 

const KolejWaskotorowaTowarzystwo = () => {
    // Standardowa destrukcja hooka
    const { t } = useTranslation(); 
    const { society, facebookUrl } = kolejWaskotorowaData;

    return (
        <>
            <PageTitle
                // Dodane tłumaczenia dla statycznych tekstów
                title={t('kolejWaskotorowa.mainTitle', 'Kolej Wąskotorowa')}
                page={t('kolejWaskotorowa.societyPage', 'Towarzystwo')}
                heading={t(society.title)}
                subTitle={t(society.subtitle)}
            />

            <section className='kw-section kw-society'>
                <div className='kw-container'>
                    
                    {/* WRAper na Heading i Logo */}
                    <div className="kw-society-header">
                        <Heading title={t(society.subtitle)} subTitle={t(society.intro)} sideHeading />
                        
                        {/* MIEJSCE NA ZDJĘCIE Z LOGIEM */}
                        <div className="kw-society-logo-wrapper">
                            {/* src może pochodzić z pliku constants (np. images.logo) lub z obiektu society.logo */}
                            <img 
                                src={images.partner9} 
                                alt={t('society.logoAlt', 'Logo Towarzystwa')} 
                                className="kw-society-logo"
                            />
                        </div>
                    </div>

                    <div className='kw-society-grid'>
                        {/* Zabezpieczenie ?. przed błędem undefined */}
                        {society.blocks?.map((block) => (
                            <article key={block.id} className='kw-info-card'>
                                <div className='kw-info-icon'>
                                    {block.id === 1 && <FaUsers />}
                                    {block.id === 2 && <FaHandsHelping />}
                                    {block.id === 3 && <FaFacebookF />}
                                </div>
                                <h3>{t(block.title)}</h3>
                                <p>{t(block.text)}</p>
                            </article>
                        ))}
                    </div>

                    <div className='kw-cta-box'>
                        <div>
                            {/* Dodane tłumaczenia dla nagłówka i opisu w sekcji kontaktowej */}
                            <h3>{t('society.ctaTitle', 'Skontaktuj się przez Facebooka')}</h3>
                            <p>
                                {t('society.ctaDesc', 'To najpewniejsza droga, jeśli chcesz dopytać o działania towarzystwa albo przesłać materiały archiwalne.')}
                            </p>
                        </div>

                        <a className='kw-button' href={facebookUrl} target='_blank' rel='noreferrer'>
                            <FaFacebookF />
                            {/* Dodane tłumaczenie dla tekstu na przycisku */}
                            {t('society.openFacebook', 'Otwórz Facebook')}
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default KolejWaskotorowaTowarzystwo;